export const deductionsColumnsDataComplex = [
  {
    Header: "YEAR",
    accessor: "year",
  },
  {
    Header: "MONTH",
    accessor: "month",
  },
  {
    Header: "VALUE",
    accessor: "value",
  },
  {
    Header: "NOTES",
    accessor: "notes",
  },
  {
    Header: "REDEEMED AT",
    accessor: "redeemedAt",
  },
];
